export interface IProductTypeConfig {
  itemType: string;
  label: string;
  labelPlural: string;
  prefix: string;
  addButtonLabel: string;
  idPlaceholder: string;
  showChecklist?: boolean;
  mainParts: string[];
  partOrder: string[];
}

export const PRODUCT_TYPES: IProductTypeConfig[] = [
  {
    itemType: 'drone',
    label: 'Drone',
    labelPlural: 'Drones',
    prefix: 'Gydron',
    addButtonLabel: 'Add drone',
    idPlaceholder: 'Drone ID',
    showChecklist: true,
    mainParts: [
      'frame',
      'motors',
      'fcstack',
      'fcsingle',
      'esc',
      'camera',
      'vtx',
      'vtxAntenna',
      'receiver',
      'propellers',
      'battery',
    ],
    partOrder: [
      'frame',
      'motors',
      'fcstack',
      'fcsingle',
      'esc',
      'camera',
      'vtx',
      'receiver',
      'antennavtx',
      'battery',
      'propellers',
    ],
  },
  {
    itemType: 'battery',
    label: 'Battery',
    labelPlural: 'Batteries',
    prefix: 'BATT',
    addButtonLabel: 'Add battery',
    idPlaceholder: 'Battery ID',
    mainParts: [
      'accumulators',
      'bms',
      'nickelStrip',
      'balancingCable',
      'powerCable',
      'batteryConnector',
      'strongAdhesiveTape',
      'captonTape',
      'carton',
      'cartonRings',
      'innerHeatShrinkTube',
      'outerHeatShrinkTube',
      'batteryStrap',
      'electricalInsulationTape',
    ],
    partOrder: [
      'accumulators',
      'bms',
      'nickelstrip',
      'balancingcable',
      'powercable',
      'batteryconnector',
      'strongadhesivetape',
      'captontape',
      'carton',
      'cartonrings',
      'innerheatshrink',
      'outerheatshrink',
      'batterystrap',
      'electricalinsulationtape',
    ],
  },
  {
    itemType: 'powerbank',
    label: 'Powerbank',
    labelPlural: 'Powerbanks',
    prefix: 'PB',
    addButtonLabel: 'Add powerbank',
    idPlaceholder: 'Powerbank ID',
    mainParts: [
      'controlBoard',
      'case',
      'accumulators',
      'wire',
      'nickelStrip',
      'springs',
      'pvcWrap',
      'cartonRings',
      'insulationCarton',
      'tape',
      'nylonTie',
    ],
    partOrder: [
      'controlboard',
      'case',
      'accumulators',
      'wire',
      'nickelstrip',
      'springs',
      'pvcwrap',
      'cartonrings',
      'insulationcarton',
      'tape',
      'nylontie',
    ],
  },
  {
    itemType: 'battery-assembly',
    label: 'Battery Assembly',
    labelPlural: 'Battery Assemblies',
    prefix: 'BA',
    addButtonLabel: 'Add battery assembly',
    idPlaceholder: 'Assembly ID',
    mainParts: [
      'accumulators',
      'bms',
      'nickelStrip',
      'balancingCable',
      'powerCable',
      'batteryConnector',
      'strongAdhesiveTape',
      'captonTape',
      'carton',
      'cartonRings',
      'innerHeatShrinkTube',
      'outerHeatShrinkTube',
      'batteryStrap',
      'nylonTie',
      'electricalInsulationTape',
    ],
    partOrder: [
      'accumulators',
      'bms',
      'nickelstrip',
      'balancingcable',
      'powercable',
      'batteryconnector',
      'strongadhesivetape',
      'captontape',
      'carton',
      'cartonrings',
      'innerheatshrink',
      'outerheatshrink',
      'batterystrap',
      'nylontie',
      'electricalinsulationtape',
    ],
  },
  {
    itemType: 'power-adapter',
    label: 'Power Adapter',
    labelPlural: 'Power Adapters',
    prefix: 'PA',
    addButtonLabel: 'Add power adapter',
    idPlaceholder: 'Adapter ID',
    mainParts: [
      'controlBoard',
      'voltageConversionBoard',
      'inputConnector',
      'inputConnectorWires',
      'outputConnector',
      'outputConnectorWires',
      'case',
      'insulation',
    ],
    partOrder: [
      'controlboard',
      'voltageconversionboard',
      'inputconnector',
      'inputconnectorwires',
      'outputconnector',
      'outputconnectorwires',
      'case',
      'insulation',
    ],
  },
];

export const PRODUCT_TYPE_MAP: Record<string, IProductTypeConfig> = Object.fromEntries(
  PRODUCT_TYPES.map((pt) => [pt.itemType, pt])
);

export const DEFAULT_PRODUCT_TYPE = 'drone';
